export default __webpack_public_path__ + "static/media/rustic-refined.c63bb2a0.jpg";